export function clearHtmlTags(value: string) {
  return value.replace(/(<([^>]+)>)/gi, '');
}
